import React from 'react'
import { RetentionRuleType } from '../../../models/RetentionPolicy'

export const RetentionPolicyRuleType: React.FC<{ type: RetentionRuleType }> = ({ type }) => {
  if (type === RetentionRuleType.TTL) {
    return <div>Time-to-live</div>
  } else if (type === RetentionRuleType.EVENT) {
    return <div>Event</div>
  }
  return <div>{type}</div>
}
